import { render } from "./BusinessView.vue?vue&type=template&id=41031f1c"
import script from "./BusinessView.vue?vue&type=script&lang=js"
export * from "./BusinessView.vue?vue&type=script&lang=js"
script.render = render

export default script